import React from "react";
import { Shield } from "lucide-react";

/**
 * Brand mark for "miapoyo · Defiende Tus Derechos"
 * size: 'sm' | 'md' | 'lg'
 */
export default function BrandMark({ size = "md", subtitle = true }) {
  const dims = {
    sm: { box: "w-7 h-7", icon: "w-4 h-4", title: "text-sm", sub: "text-[9px]" },
    md: { box: "w-9 h-9", icon: "w-5 h-5", title: "text-lg", sub: "text-[10px]" },
    lg: { box: "w-12 h-12", icon: "w-7 h-7", title: "text-2xl", sub: "text-xs" },
  }[size];

  return (
    <div className="flex items-center gap-2.5" data-testid="brand-mark">
      <div className={`${dims.box} rounded-xl bg-red-600 flex items-center justify-center shadow`}>
        <Shield className={`${dims.icon} text-white`} strokeWidth={2.75} />
      </div>
      <div className="leading-none">
        {subtitle && (
          <p className={`${dims.sub} uppercase tracking-[0.2em] font-bold text-zinc-500 mb-0.5`}>
            miapoyo.com
          </p>
        )}
        <p className={`${dims.title} font-black tracking-tight text-zinc-900`}>
          Defiende Tus Derechos
        </p>
      </div>
    </div>
  );
}
